module.exports = __webpack_public_path__ + "img/img4.c7dc5c2f.png";